module.exports = __webpack_public_path__ + "media/media/about/4-0275aae32508a3137c90d6e94e45e7fc.jpg";